<template>
  <v-container grid-list-lg>

    <v-layout row v-if="!photosActive">
        <v-flex lg6 offset-lg3>
          <h2>Please contact QGistix to activate photo capture for parts received in our reverse logistics program.</h2>
        </v-flex>
    </v-layout>
    
    <v-layout row v-if="photosActive">
        <v-flex lg4 offset-lg4>
          <h2 v-if="nameindex != null" class="grey--text">Image {{nameindex + 1}} of {{images.length}} for part id {{qid}}</h2>
          <h2 v-if="noimages" class="grey--text">No images found for part id {{qid}}</h2>
          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        </v-flex>
    </v-layout>
    <v-layout row v-if="photosActive">
        <v-flex lg10 offset-lg1>
          <v-carousel v-model="nameindex" height="800px" :continuous=false>
            <v-carousel-item
              v-for="(item,i) in images"
              :key="i"
              :src="item.field_value">
            </v-carousel-item>
          </v-carousel>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from "../config";
import axios from "axios"

  export default {
    name: 'imageview'
    ,components: {
    }
    ,data: function () {
      return {
        qid: ""
        ,images: []
        ,loading: false
        ,nameindex: null
        ,noimages: false
      }
    }
    ,computed:
    {
      clientId() {
        let users_client_id = this.$store.state.auth.profile["custom:client_id"];
        let client_id;

        if (users_client_id == "999" && this.$store.state.portalsettings.client) {
          // qgistix user w/999, and there is a client in the app setting, we use it
          client_id = String(this.$store.state.portalsettings.client.client_id);
        } // no selected client for QGistix 999 user, or a client who can only be their own client_id
        else {
          client_id = users_client_id;
        }
        return client_id;
      },
      photosActive()
      {
        return ["108", "125"].includes(this.clientId)
      }
    }
    ,watch:
    {
      qid: function(qid)
      {
        this.recalcImages()
      }
    }
    ,methods:
    {
      async recalcImages()
      {
        this.loading = true
        this.noimages = false

        if (this.qid)
        {
          try
          {
            let response = await axios.get(config.QDS + 'part/' + this.qid + '/images', { headers: { Authorization: this.$store.state.auth.idToken }})
            if (response.data.length > 0 && (!response.data[0].client_id || response.data[0].client_id == this.clientId))
            {
              this.images = response.data
              this.nameindex = 0
            }
            else
            {
              this.images = []
              this.nameindex = null
              this.noimages = true
            }
          }
          catch(e)
          {
            console.log("recalcImages exception caught!\n" + JSON.stringify(e))
            this.images = []
            this.nameindex = null
            this.noimages = true
          }
        }
        else
        {
          this.images = []
          this.nameindex = null
        }

        this.loading = false
      }
    }
    ,beforeRouteUpdate(to, from, next)
    {
      // so there's only one way to set the qid, and that is by pushing a route with the qid param
      // this is where we process that change
      // (qid setting also happens in mounted() during the page init, but that's a special case)
      this.qid = to.params.qid

      // don't forget to call next()
      next()
    }
    ,created()
    {
    }
    ,mounted()
    {
      if (this.$route.params.qid && this.$route.params.qid.length > 0)
      {
        this.qid = this.$route.params.qid
      }
    }
  }
</script>
